import { type AppOpenerAdapter } from './AppOpenerAdapter';
import { type NavigationAdapter } from '../navigation/NavigationAdapter';
import {
  getAndroidIntentUrl,
  getCustomSchemeUrl,
  getUniversalLinkingUrl,
} from '../../core/util/env';

export const createRealAppOpener = (navigation: NavigationAdapter): AppOpenerAdapter => ({
  openCustomScheme: (token, target) => {
    const url = getCustomSchemeUrl(token);
    const result = window.open(url, target);
    return { blocked: result === null };
  },
  openUniversalLink: (token, market) => {
    const url = getUniversalLinkingUrl(token, market, navigation.getCurrentUrl());
    const result = window.open(url, '_top');
    return { url, blocked: result === null };
  },
  openAndroidIntent: () => {
    const url = getAndroidIntentUrl(navigation.getCurrentUrl());
    const result = window.open(url, '_self');
    return { blocked: result === null };
  },
});
